// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactNative from "react-native";
import * as Blocks__Common from "./common/Blocks__Common.bs.js";
import * as Renderer__Context from "@pageblocks/renderer/src/Renderer__Context.bs.js";
import * as Renderer__Version from "@pageblocks/renderer/src/Renderer__Version.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Renderer__Settings from "@pageblocks/renderer/src/Renderer__Settings.bs.js";
import * as Blocks__SettingsRnAdapter from "./utils/Blocks__SettingsRnAdapter.bs.js";

var blockCode = "text";

function makeStyleFromSettings(settings, context) {
  return [
          Blocks__SettingsRnAdapter.Style.font(settings, context),
          Blocks__SettingsRnAdapter.Style.flex(settings, context, undefined, undefined),
          Blocks__SettingsRnAdapter.Style.background(settings, context),
          Blocks__SettingsRnAdapter.Style.padding(settings, context),
          Blocks__SettingsRnAdapter.Style.margin(settings, context),
          Blocks__SettingsRnAdapter.Style.border(settings, context),
          Blocks__SettingsRnAdapter.Style.position(settings, context)
        ];
}

function Blocks__Text$Component(props) {
  var __context = props.context;
  var context = __context !== undefined ? Caml_option.valFromOption(__context) : Renderer__Context.makeEmpty();
  var settings = Renderer__Settings.deserialize(props.settings);
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var getBool = function (code) {
    return Renderer__Settings.getBool(settings, code, context);
  };
  var tmp = {};
  var tmp$1 = getBool("accessibilityStateDisabled");
  if (tmp$1 !== undefined) {
    tmp.disabled = tmp$1;
  }
  var tmp$2 = getBool("accessibilityStateSelected");
  if (tmp$2 !== undefined) {
    tmp.selected = tmp$2;
  }
  var tmp$3 = Blocks__SettingsRnAdapter.Props.AccessibilityStateChecked.fromBoolOpt(getBool("accessibilityStateChecked"));
  if (tmp$3 !== undefined) {
    tmp.checked = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = getBool("accessibilityStateBusy");
  if (tmp$4 !== undefined) {
    tmp.busy = tmp$4;
  }
  var tmp$5 = getBool("accessibilityStateExpanded");
  if (tmp$5 !== undefined) {
    tmp.expanded = tmp$5;
  }
  return JsxRuntime.jsxs(ReactNative.Text, {
              accessibilityHint: getString("accessibilityHint"),
              accessibilityLabel: getString("accessibilityLabel"),
              accessibilityRole: Blocks__SettingsRnAdapter.Props.AccessibilityRole.fromStringOpt(getString("accessibilityRole")),
              accessibilityState: Caml_option.some(tmp),
              accessible: getBool("accessible"),
              children: [
                Core__Option.getOr(getString("text"), ""),
                Core__Option.getOr(props.children, null)
              ],
              ellipsizeMode: Core__Option.flatMap(getString("ellipsizeMode"), Blocks__SettingsRnAdapter.Props.EllipsizeMode.fromString),
              numberOfLines: Core__Option.map(getFloat("numberOfLines"), (function (prim) {
                      return prim | 0;
                    })),
              selectable: getBool("selectable"),
              style: Caml_option.some(makeStyleFromSettings(settings, context)),
              testID: props.testID
            });
}

var Component = {
  make: Blocks__Text$Component
};

var descriptor_meta = {
  version: 1,
  minRendererVersion: Renderer__Version.current
};

var descriptor_declaredTriggers = [];

var descriptor_declaredSettings = [
  Blocks__Common.paddingSettingGroup,
  Blocks__Common.marginSettingGroup,
  Blocks__Common.borderSettingGroup,
  Blocks__Common.layoutSettingGroup,
  Blocks__Common.backgroundSettingGroup,
  Blocks__Common.absoluteLayoutSettingGroup,
  Blocks__Common.opacitySettingGroup,
  Blocks__Common.textSettingGroup,
  Blocks__Common.accessibilitySettingGroup
];

var descriptor = {
  meta: descriptor_meta,
  code: blockCode,
  component: Component,
  declaredTriggers: descriptor_declaredTriggers,
  declaredSettings: descriptor_declaredSettings
};

var version = 1;

var minRendererVersion = Renderer__Version.current;

export {
  blockCode ,
  version ,
  minRendererVersion ,
  Component ,
  descriptor ,
}
/* react-native Not a pure module */
